import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    status: null,
    message: null,
    data: null,
    planName: null
};

export const registerSubscription = createAsyncThunk(
    "registerSubscription",
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await fetch('/api/registerSubscription', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials),
            });

            const data = await response.json();

            if (!response.ok) {
                return rejectWithValue(
                    data.message || 'Failed to register subscription'
                );
            }

            return data;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const credentialsSlice = createSlice({
    name: 'registerSubscription',
    initialState,

    extraReducers: (builder) => {

        builder.addCase(registerSubscription.pending, (state, action) => {
            state.status = 'loading';
            state.message = null;
            state.planName = action.meta.arg.planName;
        });

        builder.addCase(registerSubscription.fulfilled, (state, action) => {
            state.status = 'success';
            state.message = 'Subscription registered successfully';
            state.planName = action.meta.arg.planName;
            state.data = action.payload.data;
        });

        builder.addCase(registerSubscription.rejected, (state, action) => {
            state.status = 'error';
            state.message = action.payload || 'Failed to register subscription';
            state.planName = action.meta.arg.planName;
        });

    }
});

export default credentialsSlice.reducer;